import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../../../visual-components/typography/typography';
import { MobileOnly } from '../../../visual-components/viewport/mobile-only/mobile-only';
import styles from './total-price.module.scss';
import { TotalAmount } from './total-amount';

type Props = {
  amount?: number;
};

export const TotalPrice: React.FC<Props> = ({ amount }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.totalText}>
        <Typography fontStyle="bold" variant="maintext">
          {t('cart.cost.total')}
        </Typography>
        <Typography variant="smalltext">{t('cart.cost.excludingDeliveryFeeAndVat')}</Typography>
      </div>
      <MobileOnly>
        <TotalAmount amount={amount} />
      </MobileOnly>
    </div>
  );
};
